import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class AssetStatus extends BaseEntity {
  id                   : number;
  assetStatusCode      : string;
  name                 : string;
  rank                 : number;
}
